export interface AppTheme {
  mode: string;
  colors: {
    // Cores globais
    background: string;
    text: string;
    primary: string;
    primaryKanban: string;
    secondary: string;
    iconColor: string;
    border?: string;

    // Cores do Header
    headerBackground: string;
    headerText: string;
    headerBorder: string;
    dropdownBackground: string;
    dropdownBorder: string;
    dropdownHover: string;

    // Cores do Kanban
    cardBackground: string;
    columnBackground: string;
    columnHeaderBackground: string;
    countBadgeBackground: string;
    countBadgeText: string;
    cardBorder: string;
    modalBackground: string;
    modalHeader: string;
    inputBorder: string;
    inputFocus: string;
    buttonSave: string;
    buttonCancel: string;
    buttonEdit: string;
    buttonAdd: string;
    buttonSubmit: string;
    buttonMove: string;
    scrollThumb: string;
    scrollTrack: string;
    menuBackground: string;
    menuText: string;
    viewModeBackground: string;

    // Cores dos novos controles do Menu
    searchInputBackground: string;
    searchInputText: string;
    filterButtonBackground: string;
    filterButtonBorder: string;
    filterButtonText: string;
    filterButtonHover: string;
    filterButtonActive: string;
    filterButtonActiveText: string;
    filterButtonActiveBorder: string;

    // Novas cores para os campos de card
    fieldLabel: string;
    fieldValue: string;

    // Novas cores para o Modal refatorado
    sidebarBorder: string;
    sidebarTitleBorder: string;
    clickableFieldBackground: string;
    clickableFieldBorder: string;
    clickableFieldHover: string;
    clickableFieldHintText: string;
    clickableFieldHintBackground: string;
    emptyMessageText: string;
    modalFooterBorder: string;
    buttonCancelDarkBorder: string;
    buttonCancelDarkBackground: string;
    buttonCancelDarkText: string;
  };
}

export const lightTheme: AppTheme = {
  mode: 'light',
  colors: {
    // Cores globais
    background: '#F6F7F9',
    text: '#111827',
    primary: '#4a90e2',
    primaryKanban: '#F9FAFB',
    secondary: '#DD6435',
    iconColor: '#6B7280',
    border: "#ccc",

    // Cores do Header
    headerBackground: '#ffffff',
    headerText: '#666666',
    headerBorder: '#66666666',
    dropdownBackground: '#fff',
    dropdownBorder: '#dee2e6',
    dropdownHover: '#f5f5f5',

    // Cores do Kanban
    cardBackground: '#FFFFFF',
    columnBackground: '#F7F8FA',
    columnHeaderBackground: '#FFFFFF',
    countBadgeBackground: '#4a90e2',
    countBadgeText: '#FFFFFF',
    cardBorder: '#D1D5DB',
    modalBackground: '#F4F6F8',
    modalHeader: '#003675ff',
    inputBorder: '#D1D5DB',
    inputFocus: '#2563EB',
    buttonSave: '#4CAF50',
    buttonCancel: '#f44336',
    buttonEdit: '#f0f0f0',
    buttonAdd: '#F9FAFB',
    buttonSubmit: '#4a90e2',
    buttonMove: '#4CAF50',
    scrollThumb: '#e4e3e3ff',
    scrollTrack: '#f1f1f1',
    menuBackground: '#ffffff',
    menuText: '#6b6f75ff',
    viewModeBackground: '#f5f5f5',

    // Cores para os novos controles do Menu
    searchInputBackground: '#FFFFFF',
    searchInputText: '#374151',
    filterButtonBackground: '#FFFFFF',
    filterButtonBorder: '#D1D5DB',
    filterButtonText: '#374151',
    filterButtonHover: '#F3F4F6',
    filterButtonActive: '#2563EB',
    filterButtonActiveText: '#ffffff',
    filterButtonActiveBorder: '#2563EB',

    // Novas cores para os campos de card
    fieldLabel: '#374151',
    fieldValue: '#111827',

    // Novas cores para o Modal refatorado
    sidebarBorder: '#E6E8EB',
    sidebarTitleBorder: '#D1D5DB',
    clickableFieldBackground: '#FFFFFF',
    clickableFieldBorder: '#D1D5DB',
    clickableFieldHover: '#F3F4F6',
    clickableFieldHintText: '#78909c',
    clickableFieldHintBackground: '#eceff1',
    emptyMessageText: '#9e9e9e',
    modalFooterBorder: '#eeeeee',
    buttonCancelDarkBorder: '#e0e0e0',
    buttonCancelDarkBackground: '#ffffff',
    buttonCancelDarkText: '#00296F',
  }
};

export const darkTheme: AppTheme = {
  mode: 'dark',
  colors: {
    // Cores globais
    background: '#1E1E1E',
    text: '#E5E7EB',
    primary: '#4A90E2',
    primaryKanban: '#2A2A2A',
    secondary: '#FF7849',
    iconColor: '#9CA3AF',
    border: "#ccc",

    // Cores do Header
    headerBackground: '#2C2C2C',
    headerText: '#FFFFFF',
    headerBorder: '#444444',
    dropdownBackground: '#2C2C2C',
    dropdownBorder: '#3F3F3F',
    dropdownHover: '#3A3A3A',

    // Cores do Kanban
    cardBackground: '#2A2A2A',
    columnBackground: '#1F1F1F',
    columnHeaderBackground: '#ffffff',
    countBadgeBackground: 'rgba(255, 255, 255, 0.1)',
    countBadgeText: '#FFFFFF',
    cardBorder: '#3F3F3F',
    modalBackground: '#1F1F1F',
    modalHeader: '#4A90E2',
    inputBorder: '#3F3F3F',
    inputFocus: '#2563EB',
    buttonSave: '#34D399',
    buttonCancel: '#EF4444',
    buttonEdit: '#3F3F3F',
    buttonAdd: '#2D2D2D',
    buttonSubmit: '#4A90E2',
    buttonMove: '#22C55E',
    scrollThumb: '#3A3A3A',
    scrollTrack: '#1F1F1F',
    menuBackground: '#1F1F1F',
    menuText: '#FFFFFF',
    viewModeBackground: '#2C2C2C',

    // Cores para os novos controles do Menu
    searchInputBackground: '#2A2A2A',
    searchInputText: '#E5E7EB',
    filterButtonBackground: '#2A2A2A',
    filterButtonBorder: '#3F3F3F',
    filterButtonText: '#E5E7EB',
    filterButtonHover: '#3A3A3A',
    filterButtonActive: '#2563EB',
    filterButtonActiveText: '#FFFFFF',
    filterButtonActiveBorder: '#2563EB',

    // Novas cores para os campos de card
    fieldLabel: '#ccc',
    fieldValue: '#fff',

    // Novas cores para o Modal refatorado
    sidebarBorder: '#3F3F3F',
    sidebarTitleBorder: '#444444',
    clickableFieldBackground: '#2A2A2A',
    clickableFieldBorder: '#3F3F3F',
    clickableFieldHover: '#3A3A3A',
    clickableFieldHintText: '#9CA3AF',
    clickableFieldHintBackground: '#3F3F3F',
    emptyMessageText: '#9CA3AF',
    modalFooterBorder: '#3F3F3F',
    buttonCancelDarkBorder: '#3F3F3F',
    buttonCancelDarkBackground: '#2A2A2A',
    buttonCancelDarkText: '#E5E7EB',
  }
};
